/**
 * Domaine des devis - statuts et filtrage. **Aucune entrée-sortie.**
 *
 * Séparé de `stockage/devis.js` à dessein : ce module ne dépend de rien, donc
 * il se teste sans IndexedDB ni installation de paquets. La couche de stockage,
 * elle, tire `idb` - mélanger les deux imposait d'installer tout
 * l'environnement pour vérifier une fonction pure.
 *
 * C'est la même règle que pour le moteur (AD-3) : ce qui calcule ou décide ne
 * connaît ni le disque ni le réseau.
 */

/** Cycle de vie d'un devis - document 04. N'en inventer aucun autre. */
export const STATUTS = [
  { cle: 'brouillon', libelle: 'Brouillon', couleur: 'var(--couleur-encre-douce)' },
  { cle: 'envoye', libelle: 'Envoyé', couleur: 'var(--couleur-accent)' },
  { cle: 'regle', libelle: 'Réglé', couleur: 'var(--couleur-succes)' },
  { cle: 'annule', libelle: 'Annulé', couleur: 'var(--couleur-alerte)' },
];

/**
 * Recherche plein-texte sur la note et le nom du profil, plus filtres par
 * statut et par profil.
 *
 * En mémoire : les volumes sont faibles et un index IndexedDB coûterait plus
 * qu'il ne rapporterait (document 02, section 5).
 */
export function filtrer(devis, { texte = '', statut = '', profilId = '' } = {}) {
  const q = texte.trim().toLowerCase();
  return devis.filter((d) => {
    if (statut && d.status !== statut) return false;
    if (profilId && d.profileId !== profilId) return false;
    if (!q) return true;
    return `${d.note} ${d.profileSnapshot?.name ?? ''}`.toLowerCase().includes(q);
  });
}
